import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import axios from "axios";
import global_ from '@/misc/global.vue';

export const business = {
  namespaced: true,

  state: {
    // 系统
    business: [],
    activityInfo: [],
    activityRelations: [],
    activitySystemRelations: [],
    systemInfo: [],
    systemRelations: [],
  },

  mutations: {
    getBusiness: async (state) => {
      // 读取业务活动信息
      await axios.get(global_.BAK_URL + "getBusiness/").then(response => {
        Vue.set(state, 'business', response.data)
      })
    },
    getActivityInfo: async (state) => {
      // 读取业务活动信息
      await axios.get(global_.BAK_URL + "getActivityInfo/", {
        async: false
      }).then(response => {
        Vue.set(state, 'activityInfo', response.data)
      })
    },
    getActivityRelations: async (state) => {
      // 读取业务活动间关系
      await axios.get(global_.BAK_URL + "getActivityRelations/", {
        async: false
      }).then(response => {
        Vue.set(state, 'activityRelations', response.data)
      })
    },
    getActivitySystemRelations: async (state) => {
      // 读取业务活动与支持系统间关系
      await axios.get(global_.BAK_URL + "getActivitySystemRelations/", {
        async: false
      }).then(response => {
        Vue.set(state, 'activitySystemRelations', response.data)
      })
    },
    getSystemInfo: async (state) => {
      // 读取系统信息
      await axios.get(global_.BAK_URL + "getSystemInfo/", {
        async: false
      }).then(response => {
        Vue.set(state, 'systemInfo', response.data)
      })
    },
    getSystemRelations: async (state) => {
      // 读取所有关系信息
      await axios.get(global_.BAK_URL + "getSystemRelations/", {
        async: false
      }).then(response => {
        Vue.set(state, 'systemRelations', response.data)
        var tempArry = new Array({
          from_id: '',
          data: new Array()
        })
        var temp
        tempArry[0].from_id = response.data[0].from_id
        tempArry[0].from_data = []
        tempArry[0].from_data.push(response.data[0])
        for (var i = 0; i < response.data.length; i++) {
          temp = tempArry.findIndex((element) => {
            return element.from_id == response.data[i].from_id
          })
          if (temp == -1) {
            tempArry.push([])
            tempArry[tempArry.length - 1].from_id = response.data[i].from_id
            tempArry[tempArry.length - 1].from_data = []
            tempArry[tempArry.length - 1].from_data.push(response.data[i])
          } else {
            tempArry[temp].from_data.push(response.data[i])
          }
        }
      })
    }
  },

  actions: {
    // 读取业务活动信息
    getBusiness: (context) => {
      context.commit("getBusiness")
    },
    // 读取业务活动信息
    getActivityInfo: (context) => {
      context.commit("getActivityInfo")
    },
    // 读取业务活动间关系
    getActivityRelations: (context) => {
      context.commit("getActivityRelations")
    },
    // 读取业务活动与支撑系统间关系
    getActivitySystemRelations: (context) => {
      context.commit("getActivitySystemRelations")
    },
    // 读取系统信息
    getSystemInfo: (context) => {
      context.commit("getSystemInfo")
    },
    // 读取系统间关系
    getSystemRelations: (context) => {
      context.commit("getSystemRelations")
    }
  }
}